<template>

    <div class="row">
        <div class="col-sm-8 col-sm-offset-2">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Actieve contracten</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Medewerker</th>
                                <th>Startdatum</th>
                                <th>Einddatum</th>
                                <th>Contractnummer</th>
                                <th>Type</th>
                                <th>Functiegroep</th>
                                <th>Gebruikersgroep</th>
                                <th>Uren (Wekelijks)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="contracts.length === 0"></tr>
                            <tr v-for="contract in contracts">
                                <td>
                                    <router-link
                                        :to="{name:'hr.users.contracts', params: {uuid: contract.user.uuid}}"
                                    >
                                        {{ contract.user.fullname }}
                                    </router-link>
                                </td>
                                <td>{{ moment(contract.start).format('DD-MM-YYYY') }}</td>
                                <td>{{ contract.end !== null ? moment(contract.end).format('DD-MM-YYYY') : '&ndash;' }}</td>
                                <td>{{ contract.contractnumber }}</td>
                                <td>{{ contract.type }}</td>
                                <td>{{ contract.functiongroup }}</td>
                                <td>{{ contract.usergroup }}</td>
                                <td>{{ contract.hours }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="overlay" v-if="loading">
                    <i class="fa fa-refresh fa-spin"></i>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import moment from 'moment';

export default {

    data() {
        return {
            contracts:[],
            loading:true,
            moment:moment,
        }
    },

    methods: {
        getContracts() {
            axios.get(this.route('api.v1.hr.contracts.index'))
                .then(resp => {
                    this.contracts = resp.data.data;
                    this.loading = false;
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het ophalen van de contracten'));
        },
    },

    mounted() {
        this.getContracts();
    },

    name:'HrContractsIndex',

}

</script>
